module.exports = __webpack_public_path__ + "static/media/Færgemand_Frederik.969dec67.md";